import { render, staticRenderFns } from "./IntegrityComplianceInit.vue?vue&type=template&id=24b0aea4&scoped=true&"
import script from "./IntegrityComplianceInit.vue?vue&type=script&lang=js&"
export * from "./IntegrityComplianceInit.vue?vue&type=script&lang=js&"
import style0 from "./IntegrityComplianceInit.vue?vue&type=style&index=0&id=24b0aea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b0aea4",
  null
  
)

export default component.exports